module.exports = __webpack_public_path__ + "static/media/pic1.e82fbe3d.jpg";